<template>
   <el-dialog
    title="Session details"
    :visible.sync="dialog_visible"
    @close="onResetForm"
    width="75%">
    <template v-if="isNew">
      <h1>Create new manual session</h1>
    </template>
    <template v-else>

      <div class="d-block" v-if="commitmentId && objectForm">
        <h3>{{effort.meta.name}}</h3>
        <h5 v-if="isOptimizerEvent">(this session is was automatically created)</h5>

        <div v-if="objectForm.timeslotCollection">
          <h3>Timeslot Collection: <span :style="{color: objectForm.timeslotCollection.color}">{{objectForm.timeslotCollection.name}}</span></h3>
        </div>

        <!--
        <strong>From:</strong> {{objectForm.start|shortDateTime}}<br>
        <strong>To:</strong> {{objectForm.end|shortDateTime}}<br>
        -->

        <!-- <pre>
        commitmentId: {{objectForm.commitmentId}} | {{commitmentId}}
        tscId: {{objectForm.tscId}}
        goalId: {{objectForm.goalId}} | {{goalId}}
        </pre> -->

        <!--
        <el-button @click="openCommitmentModal(objectForm.goalId, objectForm.commitmentId)">Edit effort</el-button>
        <el-button @click="openGoalModal(objectForm.goalId)">Edit goal</el-button>
        -->
      </div>

    </template>

    <div v-if="objectForm" style="margin-bottom: 3em" @submit.native.prevent>
      <el-form label-width="160px" @submit.native.prevent>
        <el-form-item label="Title">
          <el-input
            autofocus
            :disabled="isOptimizerEvent"
            v-model="objectForm.title"
            placeholder="Title" />
        </el-form-item>

        <el-form-item label="Start">
          <date-selector
            :disabled="isOptimizerEvent"
            v-model="objectForm.start"
            type="datetime"
            placeholder="Start">
          </date-selector>
        </el-form-item>

        <el-form-item label="End">
          <date-selector
            :disabled="isOptimizerEvent"
            v-model="objectForm.end"
            type="datetime"
            placeholder="End">
          </date-selector>
          <el-row style="line-height: 1.75em; padding-top: 1em">
            <el-col :span="10"><strong>Duration (h):</strong></el-col>
            <el-col :span="14">{{duration/60}}</el-col>
          </el-row>
          <el-row style="line-height: 1.75em">
            <el-col :span="10"><strong>Duration (min):</strong></el-col>
            <el-col :span="14">{{duration}}</el-col>
          </el-row>
        </el-form-item>

        <el-form-item label="Effort">
          <el-select
            :disabled="isOptimizerEvent"
            v-model="objectForm.goalAndcommitmentId"
            placeholder="Select a effort"
            @change="onUpdateCommitmentId">
            <el-option v-for="(effort,idx) in all_available_efforts"
              :key="'effort-'+idx"
              :label="effort.label"
              :value="effort.value"
              :style="{ color: effort.color }" />
          </el-select>
        </el-form-item>
      </el-form>

      <h4 style="margin-top: 2em">Selected effort:</h4>
      <InlineCommitment v-if="commitmentId" :commitment="effort" />

      <h4 style="margin-top: 2em">Commitment belongs to goal:</h4>
      <InlineGoal v-if="goalId" :goal_id="goalId" />

      <h4 style="margin-top: 2em">Commitment is assigned to timeslot collection:</h4>
      <InlineTimeslotCollection v-if="effort" :tsc_id="effort.user.timeslotCollectionId" />
      <div v-if="effort && effort.user.timeslotCollectionId === ''">
          Not assigned
      </div>

      <h4 style="margin-top: 2em">This session corresponds to sequence item:</h4>
      <pre v-if="SHOW_DEBUG">{{seqItemId}}</pre>

      <!-- <pre>{{effort}}</pre> -->
      <!-- <pre>{{objectForm}}</pre> -->
    </div>

    <el-button style="float: right; margin: 0 1em;"
      size="small"
      type="primary"
      @click="onSaveModal">
      Save
    </el-button>

    <template v-if="isOptimizerEvent">
      <el-button
        size="small"
        @click="lockSession">
        Lock session to edit
      </el-button>
    </template>

    <template v-if="!isNew && !isOptimizerEvent">
      <el-button
        size="small"
        type="danger"
        @click="onDelete">
        Delete
      </el-button>
    </template>

    <el-button
      size="small"
      type="success"
      @click="onStartWorking">
      Start Working
    </el-button>

    <el-button style="float: right;"
      size="small"
      type="info"
      @click="$refs.modalRef.hide()" >
      Cancel
    </el-button>
  </el-dialog>
</template>

<script>
import InlineCommitment from '@/components/Inline/InlineCommitment'
import InlineGoal from '@/components/Inline/InlineGoal'
import InlineTimeslotCollection from '@/components/Inline/InlineTimeslotCollection'
import DateSelector from '@/components/Elements/DateSelector'
import moment from '@/moment-gp.js';

/* This modal is used for:
1. after creating a new event via selection in the calendar
2. selecting an optimizer event
3. selecting an user event
*/

export default {
  data: () => ({
    dialog_visible: false,
    objectForm: null,
    isNew: true,
    isOptimizerEvent: true,
    commitmentId: null,
    goalId: null,
    seqItemId: null,
    goalAndcommitmentId: [null, null],
    autoLock: false, // TODO
  }),
  computed: {
    // ...mapGetters("goal", [
      // "effort_by_goal_id_and_effort_id",
      // "effort_list_all",
      // "goal_list_state",
    // ]),

    effort_list_all() {
      return this.$models.commitment.getters.commitment_list_all;
    },

    all_available_efforts() {
      let all_efforts = this.effort_list_all.map(item => {
        // let goalMeta = this.goal_list_state[ item.goalId ].meta;
        let goalMeta = this.$models.goalMeta.getNode( item.goalId )
        return {
          label: `${item.name} (${goalMeta.cachedName})`,
          value: JSON.stringify([item.goalId, item.commitmentId]),
          color: 'black' };
      });
      let all_create_items = this.$models.goalMeta.getters.all_goals_loaded.map(item => {
        return {
          label: '<new effort for goal "' + item.cachedName + '">',
          value: JSON.stringify([item.id, -1]),
        }
      })
      return [
        { label: "Don't assign", value: JSON.stringify([null, null]) },
        ...all_efforts,
        ...all_create_items
      ];
    },

    duration() {
      if ( this.objectForm.end ) {
        let duration = moment.duration(this.objectForm.end.diff(this.objectForm.start));
        return duration.asMinutes();
      }
      return 'N/A';
    },

    effort() {
      if ( this.goalId && this.commitmentId ) {
        return this.$models.commitment.getters.commitment_list_all.find(effort => {
          return effort.commitmentId === this.commitmentId
        })
        // return this.$models.commitment.with({ goalId: this.goalId }).subscribeNode( this.commitmentId )
      }
      return null;
    },
  },
  methods: {
    showNewModal(modalData) {
      console.log("showNewModal", modalData);
      this.onResetForm();
      this.isOptimizerEvent = false;
      this.isNew = true;

      let goalAndcommitmentId = JSON.stringify([
        modalData.preselected_goal || null,
        modalData.preselected_effort || null
      ]);

      this.objectForm = Object.assign({
        title: '',
        start: null,
        end: null,
        goalAndcommitmentId: goalAndcommitmentId,
      }, modalData);
      this.dialog_visible = true;

      if ( modalData.preselected_effort ) {
        this.onUpdateCommitmentId( goalAndcommitmentId );
      }
    },

    showUpdateModal(modalData) {
      console.log("showUpdateModal", modalData);
      this.isNew = false
      this.eventId = modalData.eventId;
      this.isOptimizerEvent = modalData.isOptimizerEvent;
      this.commitmentId = modalData.commitmentId;
      this.goalId = modalData.goalId;
      this.seqItemId = modalData.seqItemId;
      this.objectForm = Object.assign({
        title: '',
        start: null,
        end: null,
        goalAndcommitmentId: JSON.stringify([this.goalId, this.commitmentId]),
      }, modalData);
      this.dialog_visible = true;
    },

    onResetForm() {
      this.eventId = null;
      this.commitmentId = null;
      this.goalId = null;
      this.seqItemId = null;
      this.objectForm = null;
    },

    onUpdateCommitmentId(jsonData) {
      let goalAndcommitmentId = JSON.parse(jsonData);
      console.log("onUpdateCommitmentId", goalAndcommitmentId);
      if ( goalAndcommitmentId[1] === -1 ) {
        console.log('Creating new effort', goalAndcommitmentId);

        this.$root.showNewModal('effort', {
          goalId: goalAndcommitmentId[0]
        }).then(({ action, data }) => {
          console.log("modal create new effort done", data);
          if ( action === 'saved' ) {
            /* The problem here is that we don't know the new id */
            this.goalId   = null;
            this.commitmentId = null;
          }
        });

      } else {
        this.goalId   = goalAndcommitmentId[0];
        this.commitmentId = goalAndcommitmentId[1];
      }
    },

    openCommitmentModal(goalId, commitmentId) {
      this.$root.showUpdateModal('effort', {
        goalId: goalId,
        commitmentId: commitmentId
      });
    },

    openGoalModal(goalId, commitmentId) {
      this.$root.showUpdateModal('goal', {
        goalId: goalId
      });
    },

    onSaveModal() {

      /* Make sure <new ...> is not selected */
      console.log("this.goalAndcommitmentId", this.goalAndcommitmentId);
      if ( this.goalAndcommitmentId[1] === -1 ) {
        this.goalAndcommitmentId = [null, null];
      }

      // TODO: validate data (make sure date is the same)
      this.dialog_visible = false;

      this.$emit('save', {
        eventId:      this.eventId,
        title:        this.objectForm.title,
        start:        this.objectForm.start, // moment(this.objectForm.start).toDate(),
        end:          this.objectForm.end, // moment(this.objectForm.end).toDate(),
        tscId:        this.effort ? this.effort.user.timeslotCollectionId : null,
        goalId:       this.goalId,
        commitmentId:     this.commitmentId,
        seqItemId:    this.seqItemId
     });
    },

    onDelete() {
      this.dialog_visible = false;
      this.$emit('delete', {
        id: this.eventId
      })
    },

    lockSession() {
      this.dialog_visible = false;
      this.$emit('save', {
        lockSession: true,
        event: {
          id:     this.eventId,
          title:  this.objectForm.title,
          start:  this.objectForm.start, // Why not moment().utc()?
          end:    this.objectForm.end,
          data: {
            tscId:        this.effort.user.timeslotCollectionId,
            goalId:       this.goalId,
            commitmentId:     this.commitmentId,
            seqItemId:    this.seqItemId
          }
        }
      });
    },

    onStartWorking() {
      this.$router.push('/session/' + this.eventId);
      this.dialog_visible = false;
    }
  },
  components: {
    InlineCommitment,
    InlineGoal,
    InlineTimeslotCollection,
    DateSelector
  }
}
</script>
